/**
 * Get an item from localStorage with the app's token name prefix
 * @param {string} key - The key to retrieve
 * @returns {string|null} - The stored value or null
 */
export function getLocalStorageItem(key) {
  return localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}${key}`);
}

export function getStoredAccessToken() {
  return getLocalStorageItem('AccessToken');
}

export function toAuthorizationHeader(token) {
  if (!token) return null;
  const raw = String(token).replace(/^Bearer\s+/i, '').trim();
  return raw ? `Bearer ${raw}` : null;
}

